import { makeStyles } from '@material-ui/core'

export const useDeskStyles = makeStyles(theme => ({
  root: {
    paddingTop: 24,
    paddingBottom: 30
  },
  divider: {
    marginBottom: theme.spacing(8) + 'px!important'
  }
}))
export const useMobStyles = makeStyles(theme => ({
  root: {
    paddingTop: 24,
    paddingBottom: 30
  }
}))
